import { IconProps } from "../../../utils/global-types/global-types";

const HomeSearchIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 21 20"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M17.28 8.897c.345 0 .625.28.625.625v9.241c0 .345-.28.625-.625.625H3.445a.625.625 0 0 1-.625-.625V9.522a.625.625 0 0 1 1.25 0v8.616h12.586V9.522c0-.345.28-.625.624-.625m-7.512-.951c2.754-.027 4.412 3.204 2.832 5.44l1.624 1.637a.625.625 0 0 1-.888.88l-1.617-1.631c-2.233 1.59-5.422-.095-5.396-2.857 0-1.853 1.45-3.371 3.267-3.464zm0 1.25c-1.21 0-2.195.996-2.195 2.22v.001c0 1.224.984 2.22 2.195 2.22 2.907-.117 2.908-4.324 0-4.44m.34-8.449a.626.626 0 0 1 .784 0l9.374 7.56h-.001c.628.54-.128 1.47-.785.973L10.5 2.037 1.518 9.281a.626.626 0 0 1-.786-.974z"
      ></path>
    </svg>
  );
};

export default HomeSearchIcon;
